import { render } from "./SpecialtyDish.vue?vue&type=template&id=5ee71aa6"
import script from "./SpecialtyDish.vue?vue&type=script&lang=js"
export * from "./SpecialtyDish.vue?vue&type=script&lang=js"

import exportComponent from "/Users/louis/Dev/source/ec/ec-food-frontend/cardholder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__